<template>
  <button
    class="add-card-btn w-full rounded-xl py-5 flex flex-col items-center justify-center gap-2.5 transition-all duration-150 active:scale-[0.98]"
    @click="$emit('click')">
    <div class="w-10 h-10 rounded-full flex items-center justify-center"
      style="background: rgba(6, 200, 255, 0.10);">
      <PlusIcon class="h-5 w-5" style="color: #06C8FF;" />
    </div>
    <span class="text-[13px] font-semibold text-muted-foreground">{{ $t('dashboard.add_card') }}</span>
  </button>
</template>

<script setup lang="ts">
import { PlusIcon } from '@heroicons/vue/24/outline'

defineEmits<{
  (e: 'click'): void
}>()
</script>

<style scoped>
.add-card-btn {
  background: var(--card);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

:is(.dark *).add-card-btn {
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
</style>
